  (function () {
    var SPACING = 16;
    var DOT_RADIUS = 2.25;
    var DOT_COLOR = '223, 237, 245';
    var ANIMATION_SPEED = 1.2;
    var instances = new WeakMap();

    function createInstance(root) {
      var canvas = root.querySelector('.halftone-background__canvas');
      if (!canvas || canvas.dataset.halftoneInit) return;

      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      canvas.dataset.halftoneInit = 'true';

      var width = 0;
      var height = 0;
      var isVisible = true;
      var rafId = null;
      var startTime = null;
      var resizeObserver = null;
      var intersectionObserver = null;

      function resize() {
        var rect = root.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);

        width = Math.max(1, rect.width);
        height = Math.max(1, rect.height);
        canvas.width = Math.max(1, Math.round(width * dpr));
        canvas.height = Math.max(1, Math.round(height * dpr));
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }

      function draw(time) {
        ctx.clearRect(0, 0, width, height);

        var cols = Math.floor(width / SPACING);
        var rows = Math.floor(height / SPACING);
        var offsetX = (width - cols * SPACING) / 2;
        var offsetY = (height - rows * SPACING) / 2;

        for (var col = 0; col <= cols; col += 1) {
          for (var row = 0; row <= rows; row += 1) {
            var x = offsetX + col * SPACING;
            var y = offsetY + row * SPACING;
            var nx = col * 0.1;
            var ny = row * 0.1;
            var wave1 = Math.sin(nx + time * 0.5) * Math.cos(ny - time * 0.3);
            var wave2 = Math.sin(nx * 0.5 - ny * 0.5 + time * 0.8);
            var value = wave1 + wave2;

            if (value <= 0.1) continue;

            var opacity = Math.min(0.85, (value - 0.1) * 1.05);

            ctx.beginPath();
            ctx.fillStyle = 'rgba(' + DOT_COLOR + ', ' + opacity.toFixed(2) + ')';
            ctx.arc(x, y, DOT_RADIUS, 0, Math.PI * 2);
            ctx.fill();
          }
        }
      }

      function loop(timestamp) {
        if (startTime === null) startTime = timestamp;
        draw(((timestamp - startTime) / 1000) * ANIMATION_SPEED);
        rafId = isVisible ? requestAnimationFrame(loop) : null;
      }

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(function () {
          resize();
        });
        resizeObserver.observe(root);
      } else {
        window.addEventListener('resize', resize);
      }

      if ('IntersectionObserver' in window) {
        intersectionObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              isVisible = entry.isIntersecting;
              if (isVisible && !rafId) rafId = requestAnimationFrame(loop);
              if (!isVisible && rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
              }
            });
          },
          { threshold: 0 }
        );
        intersectionObserver.observe(root);
      }

      resize();
      rafId = requestAnimationFrame(loop);

      instances.set(root, function () {
        if (rafId) cancelAnimationFrame(rafId);
        if (resizeObserver) resizeObserver.disconnect();
        if (intersectionObserver) intersectionObserver.disconnect();
        if (!resizeObserver) window.removeEventListener('resize', resize);
        delete canvas.dataset.halftoneInit;
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.halftone-background').forEach(createInstance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('.halftone-background').forEach(function (root) {
        var destroy = instances.get(root);
        if (destroy) destroy();
        instances.delete(root);
      });
    });
  })();
